import React, { useState, useEffect, useContext } from "react";

import "./reports.css";
import { AuthContext } from "../../../contexts/auth";

import config from "../../../config";
import { toast } from "react-toastify";
import PdfViewer from "./PdfViewer";
import {
  getTiposPagamento,
  getValoresPagamentoPorTipo,
  relatorioGeral,
} from "./RelatorioGeral/relatorioGeral";
import { relatorioPorVendedor } from "./RelatorioPorVendedor/relatorioPorVendedor";
import { relatorioPorFormaDePagamento } from "./RelatorioPorFormaDePagamento/relatorioPorFormaDePagamento";
import { relatorioResumido } from "./RelatorioResumido/relatorioResumido";
import ReactLoading from "react-loading";
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import { relatorioResumidoOrdenadoPorLocacao } from "./RelatorioResumidoOrdenadoPorLocacao/relatorioResumidoOrdenadoPorLocacao";
import { relatorioOrdenadoLugares } from "./RelatorioOrdenadoLugares/relatorioOrdenadoLugares";
import { relatorioCompleto } from "./RelatorioCompleto/relatorioCompleto";
import { relatorioGeralPdf } from "./RelatorioGeral/relatorioGeralPdf";

export default function Reports({
  event,
  dataLocacao,
  event_id,
  getEvent,
  vendedores,
  boxes,
  detailsMap,
}) {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState(null);
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    vendedor: null,
    forma_de_pagamento: null,
  });

  // ... dentro do componente Reports
  const [tiposPagamentoSelecionados, setTiposPagamentoSelecionados] = useState(
    []
  );

  const opcoesPagamento = [
    { id: "dinheiro", label: "Dinheiro" },
    { id: "pix", label: "Pix" },
    { id: "cheque", label: "Cheque" },
    { id: "outro", label: "Outro" },
  ];

  const handleCheckboxChange = (id) => {
    setTiposPagamentoSelecionados((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]
    );
    console.log(tiposPagamentoSelecionados)
  };

  const handleInputChange = (e, index, fieldName) => {
    const { value, name } = e.target;

    const updatedFormData = { ...formData };

    if (name.includes("lugares")) {
      updatedFormData.lugares[index][fieldName] = value;
    } else {
      updatedFormData[name] = value;
    }

    setFormData(updatedFormData);
    // console.log(updatedFormData);
  };

  async function _getRelatorioVendas() {
    try {
      setLoading(true);
      // alert(id)

      const response = await fetch(
        `${config.urlServer}/event/relatorios/relatorio-vendas`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            email: user.email,
            token: user.token,
            eventid: event_id,
          },
        }
      );

      if (response.status !== 200) {
        const errorData = await response.json();
        const errorMessage =
          errorData.msg || "Erro desconhecido ao buscar os eventos";
        throw new Error(errorMessage);
      }

      const json = await response.json();
      console.log(json);

      let relatorio = `numero;status;vendedor;comprador;valor_total_locacao;valor_por_lugar;lugares;valor_recebido;forma_de_pagamento;\n`;
      for (let i = 0; i < json.locacoes.length; i++) {
        let element = json.locacoes[i];

        relatorio += `${element?.numero};${element?.status};${element?.vendedor};${element?.comprador};${element?.valor_total_locacao};${element?.valor_por_lugar};${element?.lugares.length};${element?.valor_recebido};${element?.forma_de_pagamento};\n`;
      }

      downloadCsvFile(json?.relatorio, "locacoes_vendidas");

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      throw new Error(error.msg || "Ops, algo deu errado ao gerar relatório!");
    }
  }

  async function getRelatorioGeralCsv() {
    try {
      setLoading(true);

      const response = await fetch(
        `${config.urlServer}/event/relatorios/relatorio-geral`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            email: user.email,
            token: user.token,
            eventid: event_id,
          },
        }
      );

      const responseData = await response.json();

      if (response.status !== 200) {
        const errorMessage =
          responseData.msg || "Erro desconhecido ao buscar os eventos";
        throw new Error({ message: errorMessage, status: response.status });
      }

      console.log(responseData);

      let relatorio =
        "numero;status;vendedor;comprador;lugares;valor_total_locacao;valor_por_lugar;qtde_lugares;valor_recebido;tipos_pagamento;valores_pagamento;tipo-linha;\n";

      if (responseData.locacoes) {
        for (let i = 0; i < responseData.locacoes.length; i++) {
          let element = responseData.locacoes[i];
          let lugares = "";
          for (let j = 0; j < element.lugares.length; j++) {
            lugares += `${j + 1}: ${element.lugares[j].nome || ""} - ${
              element.lugares[j].documento
            } ${j === element.lugares.length - 1 ? "" : " | "}`;
          }

          // NOVO: tipos e valores
          const tiposPagamento = getTiposPagamento(element);
          const valoresPorTipo = getValoresPagamentoPorTipo(element);

          relatorio += `${element?.numero};${element?.status};${element?.vendedor};${element?.comprador};${lugares};${element?.valor_total_locacao};${element?.valor_por_lugar};${element?.lugares.length};${element?.valor_recebido};${tiposPagamento};${valoresPorTipo};locacao/mesa\n`;
        }
      }

      if (responseData.ingressos_avulsos) {
        for (let i = 0; i < responseData.ingressos_avulsos.length; i++) {
          let element = responseData.ingressos_avulsos[i];
          let lugares = "";
          for (let j = 0; j < element.lugares.length; j++) {
            lugares += `${j + 1}: ${element.lugares[j].nome || ""} - ${
              element.lugares[j].documento
            } ${j === element.lugares.length - 1 ? "" : " | "}`;
          }
          relatorio += `${element?.numero};${element?.status};${element?.vendedor};${element?.comprador};${lugares};${element?.valor_total_locacao};${element?.valor_por_lugar};${element?.lugares.length};${element?.valor_recebido};${element?.forma_de_pagamento};ingresso avulso;\n`;
        }
      }

      downloadCsvFile(relatorio, "relatorio_geral");

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      throw new Error(
        error.message || "Ops, algo deu errado ao gerar relatório!"
      );
    }
  }

  const downloadCsvFile = (value, name) => {
    console.log(value);
    const element = document.createElement("a");
    const file = new Blob([value], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = `${name}.csv`;
    document.body.appendChild(element);
    element.click();
  };



  const handleRelatorioGeralPdf = () => {
    setLoading(true);
    relatorioGeralPdf(user, event_id, event?.nome, "", tiposPagamentoSelecionados)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleRelatorioPorVendedor = () => {
    if (formData?.vendedor) {
      setLoading(true);
      relatorioGeralPdf(user, event_id, event?.nome, formData?.vendedor, tiposPagamentoSelecionados)
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      toast.error("Selecione um vendedor!");
    }
  };

  const handleRelatorioCompletoPdf = () => {
    setLoading(true);
    relatorioCompleto(user, boxes, detailsMap, event_id, event?.nome)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleRelatorioResumido = () => {
    setLoading(true);
    relatorioResumido(user, boxes, detailsMap, event_id, event?.nome)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleRelatorioResumidoOrdenadoLugares = () => {
    setLoading(true);
    relatorioOrdenadoLugares(user, boxes, detailsMap, event_id, event?.nome)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleRelatorioResumidoOrdenadoLocacao = () => {
    setLoading(true);
    relatorioResumidoOrdenadoPorLocacao(
      user,
      boxes,
      detailsMap,
      event_id,
      event?.nome
    )
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleRelatorioPorFormaDePagamento = () => {
    if (formData?.forma_de_pagamento) {
      setLoading(true);
      relatorioPorFormaDePagamento(
        user,
        boxes,
        detailsMap,
        event_id,
        formData?.forma_de_pagamento,
        event?.nome
      )
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      toast.error("Selecione uma forma de pagamento!");
    }
  };

  const _handleRelatorioPorVendedor = () => {
    if (formData?.vendedor) {
      setLoading(true);
      relatorioPorVendedor(
        user,
        boxes,
        detailsMap,
        event_id,
        formData?.vendedor,
        formData?.vendedor_nome,
        event?.nome
      )
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    } else {
      toast.error("Selecione um vendedor!");
    }
  };

  const handleRelatorioGeralCsv = () => {
    setLoading(true);
    getRelatorioGeralCsv()
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  if (!user.admin) {
    return (
        <section className="space-y-6">
          <h3 className="text-lg font-semibold text-gray-800">
            Relatórios diversos
          </h3>

          {/* CARD – FILTROS */}
          <section className="bg-white border border-gray-400 rounded-lg p-4 shadow-sm">
            <h4 className="font-medium text-gray-700 mb-2">Filtros globais</h4>

            <p className="text-sm text-gray-500 mb-4">
              O filtro de <strong>forma de pagamento</strong> é aplicado aos
              relatórios:
              <strong> Geral (PDF)</strong> e <strong> Por vendedor</strong>. Se
              nenhum for selecionado, todos serão considerados.
            </p>

            <div className="flex flex-wrap gap-4">
              {opcoesPagamento.map((op) => (
                <label
                  key={op.id}
                  className="flex items-center gap-2 text-sm text-gray-700"
                >
                  <input
                    type="checkbox"
                    className="accent-blue-600"
                    checked={tiposPagamentoSelecionados.includes(op.id)}
                    onChange={() => handleCheckboxChange(op.id)}
                  />
                  {op.label}
                </label>
              ))}
            </div>
          </section>


          {/* CARD – RELATÓRIO POR VENDEDOR */}
          <section className="bg-white border border-gray-400 rounded-lg p-4 shadow-sm space-y-3">
            <h4 className="font-medium text-gray-700">
              Relatório por vendedor
            </h4>

            <div className="flex flex-col sm:flex-row gap-3">
              <select
                name="vendedor"
                value={formData?.vendedor}
                onChange={(e) => {
                  const selectedVendedor = [
                    { id: "0", email: "semvendedor", nome: "Sem vendedor" },
                    ...vendedores,
                  ].find((item) => item.email === e.target.value);

                  if (selectedVendedor) {
                    setFormData((prev) => ({
                      ...prev,
                      vendedor: selectedVendedor.email,
                      vendedor_nome: selectedVendedor.nome,
                    }));
                  }
                }}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm"
              >
                <option value="" disabled hidden>
                  Escolha um vendedor...
                </option>

                {[
                  {
                    id: "semvendedor",
                    email: "semvendedor",
                    nome: "Sem vendedor",
                  },
                  ...vendedores,
                ].map((item) => (
                  <option key={item.email} value={item.email}>
                    {item.nome}
                  </option>
                ))}
              </select>

              <button
                onClick={handleRelatorioPorVendedor}
                className="flex items-center gap-2 text-sm text-gray-800 hover:text-blue-600"
              >
                Gerar PDF
                <BsFileEarmarkPdf size={18} color="red" />
              </button>
            </div>
          </section>


        </section>
    );
  }

  return (
    <section className="tab-reports-event">
      {loading ? (
        <article
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            padding: "10%",
          }}
        >
          <ReactLoading
            type="spinningBubbles"
            color="var(--rotary-gold)"
            height={"5%"}
            width={"5%"}
          />
        </article>
      ) : (
        <section className="space-y-6">
          <h3 className="text-lg font-semibold text-gray-800">
            Relatórios diversos
          </h3>

          {/* CARD – FILTROS */}
          <section className="bg-white border border-gray-400 rounded-lg p-4 shadow-sm">
            <h4 className="font-medium text-gray-700 mb-2">Filtros globais</h4>

            <p className="text-sm text-gray-500 mb-4">
              O filtro de <strong>forma de pagamento</strong> é aplicado aos
              relatórios:
              <strong> Geral (PDF)</strong> e <strong> Por vendedor</strong>. Se
              nenhum for selecionado, todos serão considerados.
            </p>

            <div className="flex flex-wrap gap-4">
              {opcoesPagamento.map((op) => (
                <label
                  key={op.id}
                  className="flex items-center gap-2 text-sm text-gray-700"
                >
                  <input
                    type="checkbox"
                    className="accent-blue-600"
                    checked={tiposPagamentoSelecionados.includes(op.id)}
                    onChange={() => handleCheckboxChange(op.id)}
                  />
                  {op.label}
                </label>
              ))}
            </div>
          </section>

          {/* CARD – RELATÓRIOS PDF */}
          <section className="bg-white border border-gray-400 rounded-lg p-4 shadow-sm space-y-3">
            <h4 className="font-medium text-gray-700">Relatórios em PDF</h4>

            <button
              onClick={handleRelatorioResumidoOrdenadoLugares}
              className="flex items-center gap-2 text-sm text-gray-800 hover:text-blue-600"
            >
              Relatório resumido por lugares (A–Z)
              <BsFileEarmarkPdf size={18} color="red" />
            </button>

            <button
              onClick={handleRelatorioGeralPdf}
              className="flex items-center gap-2 text-sm text-gray-800 hover:text-blue-600"
            >
              Relatório geral
              <BsFileEarmarkPdf size={18} color="red" />
            </button>

            <button
              onClick={handleRelatorioResumidoOrdenadoLocacao}
              className="flex items-center gap-2 text-sm text-gray-800 hover:text-blue-600"
            >
              Relatório por número de locação
              <BsFileEarmarkPdf size={18} color="red" />
            </button>

            <button
              onClick={handleRelatorioResumido}
              className="flex items-center gap-2 text-sm text-gray-800 hover:text-blue-600"
            >
              Relatório por comprador
              <BsFileEarmarkPdf size={18} color="red" />
            </button>
          </section>

          {/* CARD – RELATÓRIO POR VENDEDOR */}
          <section className="bg-white border border-gray-400 rounded-lg p-4 shadow-sm space-y-3">
            <h4 className="font-medium text-gray-700">
              Relatório por vendedor
            </h4>

            <div className="flex flex-col sm:flex-row gap-3">
              <select
                name="vendedor"
                value={formData?.vendedor}
                onChange={(e) => {
                  const selectedVendedor = [
                    { id: "0", email: "semvendedor", nome: "Sem vendedor" },
                    ...vendedores,
                  ].find((item) => item.email === e.target.value);

                  if (selectedVendedor) {
                    setFormData((prev) => ({
                      ...prev,
                      vendedor: selectedVendedor.email,
                      vendedor_nome: selectedVendedor.nome,
                    }));
                  }
                }}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm"
              >
                <option value="" disabled hidden>
                  Escolha um vendedor...
                </option>

                {[
                  {
                    id: "semvendedor",
                    email: "semvendedor",
                    nome: "Sem vendedor",
                  },
                  ...vendedores,
                ].map((item) => (
                  <option key={item.email} value={item.email}>
                    {item.nome}
                  </option>
                ))}
              </select>

              <button
                onClick={handleRelatorioPorVendedor}
                className="flex items-center gap-2 text-sm text-gray-800 hover:text-blue-600"
              >
                Gerar PDF
                <BsFileEarmarkPdf size={18} color="red" />
              </button>
            </div>
          </section>

          {/* CARD – EXPORTAÇÃO */}
          <section className="bg-white border border-gray-400 rounded-lg p-4 shadow-sm">
            <h4 className="font-medium text-gray-700 mb-2">Exportações</h4>

            <button
              onClick={handleRelatorioGeralCsv}
              className="flex items-center gap-2 text-sm text-gray-800 hover:text-green-600"
            >
              Relatório geral (CSV)
              <BsFiletypeCsv size={18} color="green" />
            </button>
          </section>
        </section>
      )}
    </section>
  );
}
